export const ELLIPSIS = "…"
export const ELLIPSIS_BEFORE = "ELLIPSIS_BEFORE"
export const ELLIPSIS_AFTER = "ELLIPSIS_AFTER"

export function generateRange({
  currentPage,
  lastPage,
  siblingsCount = 0,
}: {
  currentPage: number
  lastPage: number
  siblingsCount?: number
}): (number | "ELLIPSIS_AFTER" | "ELLIPSIS_BEFORE")[] {
  // first page + last page + current page + 2 ellipsis + siblings
  const rangeLength = 5 + siblingsCount
  const sideRangeLength = rangeLength - 2
  const centralRangeLength = rangeLength - 4
  const sideSiblingCount = siblingsCount / 2

  // Show all
  if (lastPage <= rangeLength) {
    return Array.from({ length: lastPage }, (_, idx) => idx + 1)
  }

  // Show range from start + ellipsis + last page
  if (sideRangeLength - currentPage >= 0 && currentPage + sideSiblingCount < 1 + sideRangeLength) {
    return [...Array.from({ length: sideRangeLength }, (_, idx) => idx + 1), ELLIPSIS_AFTER, lastPage]
  }

  // Show first page + ellipsis + range to end
  if (sideRangeLength - (lastPage - currentPage) >= 0 && currentPage - sideSiblingCount > lastPage - sideRangeLength) {
    return [
      1,
      ELLIPSIS_BEFORE,
      ...Array.from({ length: sideRangeLength }, (_, idx) => lastPage - sideRangeLength + idx + 1),
    ]
  }

  // Show first page + ellipsis + range + ellipsis + last page
  return [
    1,
    ELLIPSIS_BEFORE,
    ...Array.from({ length: centralRangeLength }, (_, idx) => currentPage - sideSiblingCount + idx),
    ELLIPSIS_AFTER,
    lastPage,
  ]
}
